import { node } from "~/util/dom";
import { ISubscriptionWithDescription } from "~/util/providers/share-position/interfaces";
import { createSubscriptionTextInfo } from "~/ui/share-position/share-position-subscription-text";
import { createSubscriptionTextInfo as createSubscriptionTextInfo2 } from "~/ui/share-position/share-position-subscription-text2";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import { STALE_TIMEOUT, createMapDeviceIcon } from "~/share-position2/utils";

interface IAvatarMarkerOptions {
	onClick?: (event: PointerEvent) => void;
	onCardClick?: (event: PointerEvent) => void;
	index: number;
}

export default function AvatarMarker(subscription: ISubscriptionWithDescription, options: IAvatarMarkerOptions = { index: 0 }) {
	SMap.WMMarker.call(this, null, undefined, {
		elm: node("mapy-avatar", { className: Mapy.CUS.userweb?.generalSharePosition ? "ui-avatar-marker2" : "ui-avatar-marker" }),
		size: [44, 44],
		anchor: {
			left: 22,
			top: 22,
		},
	});

	this._subscriptionIndex = options.index;
	this.updateData(subscription);
	this.setCardOptions({
		anchor: {
			left: 0,
			top: Mapy.CUS.userweb?.generalSharePosition ? 27 : 19,
		},
		onClick: options?.onCardClick,
	});

	if (options?.onClick) {
		this._dom.container[SMap.LAYER_MARKER].addEventListener("click", options.onClick, false);
	}
}

// eslint-disable-next-line prefer-object-spread
AvatarMarker.prototype = Object.create(Object.assign({}, SMap.Marker.prototype, SMap.WMMarker.prototype));

AvatarMarker.prototype.updateData = function updateData(subscription: ISubscriptionWithDescription) {
	this._subscription = subscription;
	this._dom.container[SMap.LAYER_MARKER].innerHTML = `<img src="${subscription.sharingType === "device" ? createMapDeviceIcon(this._subscriptionIndex + 1) : subscription.user.avatarUrl}" />`;

	if (subscription.position && "azimuth" in subscription.position) {
		this._dom.container[SMap.LAYER_MARKER].setAttribute("azimuth", subscription.position.azimuth);
	} else {
		this._dom.container[SMap.LAYER_MARKER].removeAttribute("azimuth");
	}

	this.setCoords(new SMap.Coords(subscription.position.lon, subscription.position.lat));

	if (subscription.sharingStatus === "active" && new Date(subscription.positionTime).getTime() + STALE_TIMEOUT >= new Date().getTime()) {
		this._dom.container[SMap.LAYER_MARKER].removeAttribute("inactive");
	} else {
		this._dom.container[SMap.LAYER_MARKER].setAttribute("inactive", "inactive");
	}

	this.setPopupCallback(card => {
		this._setPopupCont(card, subscription);
	});
};

AvatarMarker.prototype._build = function _build() {
	this._dom.container[SMap.LAYER_MARKER] = this._conf.elm;

	if (this._options.title) {
		this._dom.container[SMap.LAYER_MARKER].title = this._conf.title;
	}

	this._dom.active = this._dom.container[SMap.LAYER_MARKER];

	this._options.anchor = this._conf.anchor;

	// eventy
	this._dom.container[SMap.LAYER_MARKER].addEventListener("mouseenter", this, false);
	this._dom.container[SMap.LAYER_MARKER].addEventListener("mouseleave", this, false);
};

AvatarMarker.prototype.setSelected = function setSelected(selected = false) {
	if (selected) {
		this._dom.container[SMap.LAYER_MARKER].setAttribute("selected", "selected");
	} else {
		this._dom.container[SMap.LAYER_MARKER].removeAttribute("selected");
	}
};

AvatarMarker.prototype.setIndex = function setIndex(index) {
	this._subscriptionIndex = index;

	if (this._subscription.sharingType === "device") {
		this._dom.container[SMap.LAYER_MARKER].innerHTML = `<img src="${createMapDeviceIcon(this._subscriptionIndex + 1)}" />`;
	}
};

AvatarMarker.prototype._setPopupCont = function _setPopupCont(card, subscription: ISubscriptionWithDescription) {
	const cardBody = card.getBody();

	cardBody.innerHTML = "";
	if (Mapy.CUS.userweb?.generalSharePosition) {
		cardBody.appendChild(createSubscriptionTextInfo2(subscription, CONFIG.defaultLang, _));
	} else {
		cardBody.appendChild(createSubscriptionTextInfo(subscription, CONFIG.defaultLang, _));
	}
};

AvatarMarker.prototype._createCard = function _createCard() {
	SMap.WMMarker.prototype._createCard.call(this);

	if (Mapy.CUS.userweb?.generalSharePosition) {
		this._dom.card.classList.add("avatar-marker-popup2");
	} else {
		this._dom.card.classList.add("avatar-marker-popup");
	}

	if (this._cardOpts.onClick) {
		this._dom.card.addEventListener("click", this._cardOpts.onClick, false);
	}
};
